import React from 'react';
import { Box, Typography, Tooltip, Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import ExportConfig from '../../../../components/buttons/ExportConfig';
import DateRangePicker from '../../../../components/filters/DateRangePicker';
import ChipFilter from '../../../../components/filters/ChipFilter';
import styles from './EVNFilters.styles';

const EVNFilters = ({
  filters,
  setFilters,
  dateRange,
  setDateRange,
  evnOptions = [],
  trainNumberOptions = [],
  onAdd,
}) => {
  // const [searchParams] = useSearchParams();

  const evns = filters.evn || [];
  const trains = filters.trainNumber || [];

  const toggleFilter = (type, value) => {
    setFilters(prev => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter(v => v !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  };

  const clearFilter = (type) => {
    setFilters(prev => ({ ...prev, [type]: [] }));
  };

  return (
    <Box sx={styles.filterRow}>
      {/* Left: Chips + Date */}
      <Box sx={styles.filterLeft}>
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 600 }}>
          Filters:
        </Typography>

        <ChipFilter
          label="EVN"
          type="evn"
          values={evnOptions}
          selectedValues={evns}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <ChipFilter
          label="Train"
          type="trainNumber"
          values={trainNumberOptions}
          selectedValues={trains}
          onToggle={toggleFilter}
          onClear={clearFilter}
        />

        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </Box>

      {/* Right: Actions */}
      <Box sx={styles.rightControls}>
        <ExportConfig sx={styles.fabButton} />

        <Tooltip title="Add new EVN" arrow>
          <Fab size="small" sx={styles.fabButton} onClick={onAdd}>
            <AddIcon fontSize="small" />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default EVNFilters;
